export const safeParseJSON = <T>(
  value: string | null | undefined,
  fallback: T
): T => {
  if (!value || value === 'undefined') {
    return fallback
  }

  try {
    return JSON.parse(value) as T
  } catch {
    return fallback
  }
}
